import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class PsrService {

  constructor(
    private http: HttpService,
  ) { }

  filter(data?: any) {
    return this.http.post(Path.PAYMENT_SUMMARY_REPORT.FILTER, data);
  }
  generate(data?: any) {
    return this.http.post(Path.PAYMENT_SUMMARY_REPORT.GENERATE, data);
  }

}